import * as React from 'react';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import { withRouter } from '../common/with-router';
import { Box, Typography, ToggleButton, ToggleButtonGroup } from '@mui/material';
import ContentTimeline from './home-contentTimeline.component';
import Calendar from './calendar.component';

function TODO (props) {
    const [view, setView] = React.useState('timeline');

    const handleViewChange = (event, newView) => {
        if (newView !== null) {
            setView(newView);
        }
    };

    return(
        <>
        <Grid item xs={12} md={12} lg={12}>
            <Paper
            sx={{
                p: 2,
                display: 'flex',
                flexDirection: 'column',
                height: '80vh',
            }}
            >
                <Box 
                sx={{
                    display:'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    mb: 2
                }}>
                    <Typography variant='h4' color="text.primary">
                        {props.name}
                    </Typography>
                    <ToggleButtonGroup
                        value={view}
                        exclusive
                        onChange={handleViewChange}
                        aria-label="view toggle"
                        size="small"
                    >
                        <ToggleButton value="timeline" aria-label="timeline view">
                            Timeline
                        </ToggleButton>
                        <ToggleButton value="calendar" aria-label="calendar view">
                            Calendar
                        </ToggleButton>
                    </ToggleButtonGroup>
                </Box>
                <Box sx={{ flex: 1, overflow: 'auto' }}>
                    {view === 'timeline' ? (
                        <ContentTimeline reload={props.reload} setReload={props.setReload} />
                    ) : (
                        <Calendar reload={props.reload} setReload={props.setReload} />
                    )}
                </Box>
            </Paper>
        </Grid>
        </>
    )
}

export default withRouter(TODO)